import MenuContentItems from './MenuContentItems';

export default MenuContentItems;
